import { useEffect, useState, useRef } from "react";
import { examStartApi } from "../services/service";
import socket from "../socket/socket";
import FinalSubmissionDialog from "./popups/FinalSubmissionDialog";
import { decryptData } from "../crypto";
import { useTimeLeft } from "../context/TimeLeftContext";
import { CircularProgress } from "@mui/material";

export let leftTime = "";

function TimerComponent({
  setIsTimeUp,
  showSubmitModal,
  handleCloseSubmitModal,
  handleFinalSubmit,
  isTimeUp,
  stats,
  submitError,
  countdownTime,
  finalSubmitChecked,
  setIsOnSubmit,
  handleFinalSubmitCheck,
  isFormatTime=false,
  onInitialized = () => {},
}) {
  const [remainingTime, setRemainingTime] = useState(
    sessionStorage.getItem("remainingTime") || ""
  );
  const [extraTime, setExtraTime] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);

  const  {setTimeLeft} = useTimeLeft()

   const setIsTimeUpRef = useRef(setIsTimeUp);
  const setIsOnSubmitRef = useRef(setIsOnSubmit);
  const setTimeLeftRef = useRef(setTimeLeft);

  // Update refs on every render so they always point to the latest functions
  setIsTimeUpRef.current = setIsTimeUp;
  setIsOnSubmitRef.current = setIsOnSubmit;
  setTimeLeftRef.current = setTimeLeft;

  function formatTime(input) {
    // Split the input by ":"
    const parts = input.split(":");

    // Ensure we have exactly 3 parts (hh:mm:ss)
    if (parts.length !== 3) return input;

    const [hours, minutes, seconds] = parts;

    return `${hours} hr : ${minutes} min : ${seconds} sec`;
  }

  const fetchExamStartApi = async (examId) => {
    if (
      sessionStorage.getItem("relogin") ||
      sessionStorage.getItem("submitByH")
    ) {
      setIsInitialized(true);
      return;
    }
    try {
      const responseData = await examStartApi(examId);
      if (responseData) {
        const examDurationInSeconds = responseData?.time_left;
        const storedTime = sessionStorage.getItem("remainingTime");

        // Use stored time if valid, otherwise use API response
        const initialTime =
          storedTime && storedTime !== "00:00:00"
            ? storedTime
            : examDurationInSeconds;

        setRemainingTime(initialTime);
        sessionStorage.setItem("remainingTime", initialTime);
        sessionStorage.setItem("examDuration", examDurationInSeconds);
      }
      setIsInitialized(true);
    } catch (error) {
      console.error("Error fetching start time of the exam:", error);
      setIsInitialized(true);
    }
  };

  function timeStringToSeconds(timeString) {
    if (!timeString || timeString === "00:00:00") return 0;
    const [hours, minutes, seconds] = timeString.split(":").map(Number);
    return hours * 3600 + minutes * 60 + seconds;
  }

  function secondsToTimeString(totalSeconds) {
    if (totalSeconds <= 0) return "00:00:00";
    const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
    const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(
      2,
      "0"
    );
    const seconds = String(totalSeconds % 60).padStart(2, "0");
    return `${hours}:${minutes}:${seconds}`;
  }

  // useEffect(() => {
  //   const examId = sessionStorage.getItem("examId");
  //   if (examId) {
  //     fetchExamStartApi(examId);
  //   } else {
  //     setIsInitialized(true);
  //   }
  // }, []);

  useEffect(() => {
    const examId = sessionStorage.getItem("examId");

    if (examId && !sessionStorage.getItem("apiCalled")) {
      fetchExamStartApi(examId);
      sessionStorage.setItem("apiCalled", "true");
    } else {
      setIsInitialized(true);
    }

    setTimeout(() => {
      sessionStorage.removeItem("apiCalled");
    }, 3000);
  }, []);

  useEffect(() => {
    if (!isInitialized) return;

    socket.connect();
    const user = sessionStorage.getItem("userId");
    const exam = sessionStorage.getItem("examId");

    const handleExtraTime = ({ examId, userIds, extraTime }) => {
      if (
        userIds.map(String).includes(user) &&
        Number(exam) === Number(examId)
      ) {
        const storeTime = Number(sessionStorage.getItem("extraTime") || 0);
        const total = storeTime + Number(extraTime);

        setExtraTime(extraTime);
        sessionStorage.setItem("extraTime", total);
      }
    };

    socket.on("extra_time", handleExtraTime);

    return () => {
      socket.off("extra_time", handleExtraTime);
      socket.disconnect();
    };
  }, [isInitialized]);

  useEffect(() => {
    if (!isInitialized || !extraTime) return;

    const oldTime = timeStringToSeconds(sessionStorage.getItem("examDuration"));
    const currentTime = timeStringToSeconds(remainingTime);
    const totalTime = currentTime + Number(extraTime);

    const newRemainingTime = secondsToTimeString(
      totalTime <= oldTime ? totalTime : oldTime
    );

    sessionStorage.setItem("remainingTime", newRemainingTime);
    setRemainingTime(newRemainingTime);
    setExtraTime(null); // Reset extra time after applying
  }, [extraTime, isInitialized]);

  useEffect(() => {
    if (!isInitialized) return;

    const interval = setInterval(() => {
      setRemainingTime((prevTime) => {
        // const newTime = decrementTime(prevTime, setIsTimeUp, setIsOnSubmit);
         const newTime = decrementTime(
          prevTime,
          setIsTimeUpRef.current,
          setIsOnSubmitRef.current
        );
        leftTime = newTime;
        // setTimeLeft(newTime);
         setTimeLeftRef.current(newTime);
        sessionStorage.setItem("remainingTime", newTime);
        return newTime;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isInitialized]);

  useEffect(() => {
    if (isInitialized) {
      onInitialized(true);
    }
  }, [isInitialized, onInitialized]);

  return (
    <>
      {isInitialized ? (
        isFormatTime ? (
          formatTime(remainingTime)
        ) : (
          remainingTime
        )
      ) : null}
      <FinalSubmissionDialog
        open={showSubmitModal || isTimeUp}
        onClose={handleCloseSubmitModal}
        onSubmit={handleFinalSubmit}
        isTimeUp={isTimeUp}
        stats={stats}
        submitError={submitError}
        countdownTime={countdownTime}
        finalSubmitChecked={finalSubmitChecked}
        onFinalSubmitCheck={handleFinalSubmitCheck}
      />
    </>
  );
}

function decrementTime(timeString, setIsTimeUp, setIsOnSubmit) {
  if (sessionStorage.getItem("isTimeUp")) {
    if (
      decryptData(sessionStorage.getItem("exam_template")) === "ssc/railway"
    ) {
      sessionStorage.setItem("isOnsubmit", true);
      setIsOnSubmit(true);
    }
    setIsTimeUp(true);
    return "00:00:00";
  }

  let totalSeconds = timeString.split(":").reduce((acc, time, index) => {
    return acc + Number(time) * [3600, 60, 1][index];
  }, 0);

  if (totalSeconds <= 1) {
    sessionStorage.setItem("isTimeUp", true);
    if (
      decryptData(sessionStorage.getItem("exam_template")) === "ssc/railway"
    ) {
      sessionStorage.setItem("isOnsubmit", true);
      setIsOnSubmit(true);
    }
    setIsTimeUp(true);
    return "00:00:00";
  }

  totalSeconds -= 1;

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return [
    String(hours).padStart(2, "0"),
    String(minutes).padStart(2, "0"),
    String(seconds).padStart(2, "0"),
  ].join(":");
}

export default TimerComponent;
